"use client";
import { useEffect } from "react";
import { usePathname } from "next/navigation";
import { getSupabaseBrowserClient } from "@/lib/supabase";

export function trackEvent(eventName: string, metadata: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  try {
    const supabase = getSupabaseBrowserClient();
    void supabase.auth.getSession().then(({ data }) => fetch("/api/analytics", { method: "POST", headers: { "Content-Type": "application/json", ...(data.session?.access_token ? { Authorization: "Bearer " + data.session.access_token } : {}) }, body: JSON.stringify({ eventName, path: window.location.pathname, metadata }) }).catch(() => undefined));
  } catch { /* analytics must never block user workflows */ }
}

export function AnalyticsTracker() {
  const pathname = usePathname();
  useEffect(() => { trackEvent("page_view", { pathname }); }, [pathname]);
  return null;
}
